import Quagga from 'quagga'
import moment from 'moment'
import pluralize from 'pluralize'
import { AiOutlineBarcode } from 'react-icons/ai'
import { Drawer, AutoComplete, Table } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import React, { useEffect, useState, useRef } from 'react'

import { usePet, useToggle } from '../../modules'

import Modal from '../reusable/modal'
import Confirm from '../reusable/confirm'
import Datepicker from '../reusable/datePicker'

const EditItem = ({ visible, toggle, records, onSave = () => null, selected, index, id, onSuccess = () => null }) => {
    const record = ((records ?? {})[selected?._id] ?? {})[index]

    const [quantity, setQuantity] = useState(record?.quantity ?? 0)
    const [expiry, setExpiry] = useState(record?.expiry)
    const [batchNo, setBatchNo] = useState(record?.batchNo ?? 'default')

    const onComplete = ({ data }, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        onSuccess(data)
    }

    const [, fill] = usePet('fillTally', {
        id,
        index,
        item: selected?._id,
        batchNo,
        quantity,
        expiry,
        add: false,
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Saving changes...' } })

    const save = () => {
        fill()

        setTimeout(() => {
            onSave({
                item: selected,
                quantity,
                expiry,
                batchNo
            }, index)

            toggle()
        }, 300)
    }

    return (
        <Modal
            w={400}
            title={index >= 0 ? 'Edit Tally' : 'Add New Tally'}
            toggle={toggle}
            visible={visible}>
            <p className="text-gray-700 italic text-sm mb-2">{selected?.name}</p>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Quantity
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        type="number"
                        name="quantity"
                        value={quantity}
                        onChange={e => setQuantity(e.target.value)}
                        placeholder="Items" />
                </div>
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Batch No.
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        type="text"
                        name="batchNo"
                        value={batchNo}
                        onChange={e => setBatchNo(e.target.value)}
                        placeholder="8923873" />
                </div>
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Expiry
                    </label>
                    <Datepicker
                        format="MM/YYYY"
                        placeholder="Select Expiry Date"
                        picker="month"
                        value={expiry}
                        onChange={setExpiry} />
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={save} type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Add New Tally</button>
            </div>
        </Modal>
    )
}

const SelectItem = ({ visible, toggle, records, selected, onSelect = () => null, toggleEdit = () => null }) => {
    const edit = () => {
        toggleEdit()
        toggle()
    }

    const columns = [
        {
            title: 'Item',
            dataIndex: 'item',
            render: (item) => <span>{item?.name}</span>
        },
        {
            title: 'Expiry',
            dataIndex: 'expiry',
            render: (_, records) => <span>{moment(records[0]?.expiry)?.format('MM/YYYY')}</span>
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            render: (quantity, records) => {
                // console.log({pluralize(records[0]?.item?.unit, quantity)})
                return <span>{quantity} </span>
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record, index) => <button onClick={() => onSelect(index)} className="btn py-1 px-2 hisani-btn-green-light text-white">Add to This</button>
        }
    ]

    return (
        <Modal
            w={400}
            title="Select Item"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <Table
                    dataSource={records[selected?._id]}
                    columns={columns} />
            </div>
            <div className="flex justify-end">
                <button onClick={edit} type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Add New Tally</button>
            </div>
        </Modal>
    )
}

const StockTakeTally = ({ items, onPerform = () => null }) => {
    const [index, setIndex] = useState()
    const [string, setString] = useState('')
    const [visible, toggle] = useToggle(true)
    const [devices, setDevices] = useState([])
    const [records, setRecords] = useState({})
    const [selected, setSelected] = useState()
    const [scanning, setScanning] = useState(false)
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [options, setOptions] = useState(items.map(item => ({ value: item._id, label: item.name, ...item })))

    const parseTally = (data) => {
        let recs = {}

        data.items.forEach(itm => {
            recs[itm.item._id] = {
                item: itm.item,
                quantity: 0,
                batchNo: itm.batchNo,
                expiry: itm.expiry,
            }
        })

        setRecords(recs)
    }

    const { id } = useParams()

    const [, getItem] = usePet('tally', { id }, { notify: true, callback: ({ data }) => parseTally(data) })

    const videoRef = useRef(null)

    const history = useHistory()

    const [select, toggleSelect] = useToggle()
    const [edit, toggleEdit] = useToggle()

    const close = () => {
        toggle()
        setTimeout(() => history.goBack(), 300)
    }

    const save = () => {
        // Implement save functionality
    }

    const selectItem = (value) => {
        const match = items.find(item => filter(item, value))
        if (match) {
            setSelected(match)

            if (records[value]) {
                toggleSelect()
            } else {
                toggleEdit()
            }
        }
        // setRecords([...records, { item: selectedItem, quantity: 1 }])
    }

    const filter = (item, value) => {
        let status = item.name?.toLowerCase().includes(value) || item._id?.toLowerCase().includes(value)

        if (item.code)
            status = status || item.code?.toLowerCase().includes(value)

        return status
    }

    const search = (string, launch = false) => {
        setString(string)
        const search = string.trim().toLowerCase()
        const filtered = items.filter(item => filter(item, search))
        setOptions(filtered.map(item => ({ value: item._id, label: item.name, ...item })))

        if (launch) {
            if (filtered.length === 1) {
                selectItem(filtered[0]._id)
            }
        }
    }

    const getAvailableDevices = async () => {
        try {
            await navigator.mediaDevices.getUserMedia({ audio: false, video: true });
            const availableDevices = await navigator.mediaDevices.enumerateDevices();
            // const availableVideoDevices = availableDevices.filter(device => device.kind === 'videoinput');
            if (availableDevices.length > 0) {
                setDevices(availableDevices);
                setSelectedDevice(availableDevices[0]);
            }
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getAvailableDevices()
    }, [items])

    useEffect(() => {
        if (devices.length > 0) {
            setSelectedDevice(devices[0])
        }
    }, [devices])

    const stopScanning = () => {
        setScanning(false)
        Quagga.stop()
    }

    const startScanning = () => {
        setSelectedDevice(devices[0]);
        setString('')

        setTimeout(() => {
            if (selectedDevice && videoRef.current) {
                setScanning(true)
                Quagga.init({
                    inputStream: {
                        name: "Live",
                        type: "LiveStream",
                        target: videoRef.current,
                        constraints: {
                            deviceId: selectedDevice.deviceId
                        },
                    },
                    decoder: {
                        readers: ["code_39_reader"]
                    },
                }, function (err) {
                    if (err) {
                        console.log(err);
                        return
                    }
                    // console.log("Initialization finished. Ready to start");
                    Quagga.start();
                });

                Quagga.onDetected((result) => {
                    setSelectedDevice(null)
                    search(result.codeResult.code, true)
                    stopScanning()
                    // console.log("Barcode detected and processed : [" + result.codeResult.code + "]", result);
                    // Handle the scanned barcode here
                });
            }
        }, 500)
    }

    const columns = [
        {
            title: 'Item',
            dataIndex: 'item',
            render: (_, records) => <span>{records[0]?.item?.name}</span>
        },
        {
            title: 'Records',
            dataIndex: 'records',
            render: (_, records) => {
                let count = Object.keys(records).filter(itm => !isNaN(itm)).length
                return <span>{count} {pluralize('Record', count)}</span>
            }
        }
    ]

    const onSelect = (i) => {
        setIndex(i)
        toggleSelect()
        toggleEdit()
    }

    const onSave = (record, index) => {
        let temp = records[selected?._id] ?? []

        if (isNaN(index)) {
            setRecords({
                ...records,
                [selected?._id]: [...temp, record]
            })
        } else {
            temp[index] = record
            setRecords({
                ...records,
                [selected?._id]: temp
            })
        }
    }

    useEffect(() => {
        return () => {
            if (scanning) {
                Quagga.stop()
            }
        }
    }, [scanning])

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={() => Confirm({
                        title: 'Complete Tally?',
                        message: 'Please confirm before completing this tally?',
                        onOk: save,
                        okText: 'Complete Tally',
                    })} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Complete Tally</button>
                </div>
            }
            width="100%">
            <p className="font-extrabold text-3xl mb-0">Perform Tally</p>
            {
                select &&
                <SelectItem
                    selected={selected}
                    visible={select}
                    records={records}
                    toggleEdit={() => {
                        setIndex()
                        toggleEdit()
                    }}
                    onSelect={onSelect}
                    toggle={toggleSelect}
                />
            }
            {
                edit &&
                <EditItem
                    id={id}
                    visible={edit}
                    toggle={toggleEdit}
                    selected={selected}
                    records={records}
                    onSave={onSave}
                    onSuccess={parseTally}
                    index={index}
                />
            }
            <div className="divide-y divide-light-gray-400">
                <div className="w-full flex items-center justify-center mb-2">
                    <AutoComplete
                        options={options}
                        // style={{ width: 200 }}
                        onSelect={selectItem}
                        onSearch={search}
                    >
                        <input
                            value={string}
                            className="appearance-none block w-11/12 md:w-1/2 lg:w-1/3 xl:w-1/4  bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                            id="grid-search"
                            type="text"
                            placeholder="Search Item Name or SKU" />
                    </AutoComplete>
                    <button
                        className="btn ml-2 py-3 px-3 hisani-btn-green-light text-white"
                        onClick={scanning ? stopScanning : startScanning}
                    >
                        <AiOutlineBarcode style={{ color: "white" }} />
                    </button>
                </div>
                {selectedDevice && (
                    <div>
                        {/* <p>Using camera: {selectedDevice.label}</p> */}
                        <div className="w-full" ref={videoRef} />
                    </div>
                )}
                <Table
                    columns={columns}
                    footer={null}
                    className="mt-2"
                    dataSource={Object.keys(records).map(key => ({ key, ...records[key] }))}
                    expandable={{
                        expandedRowRender: (record) => (
                            <table className="table-auto w-full">
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No.</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Expiry</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Batch No.</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Quantity</div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        (Object.keys(record) ?? []).filter(itm => !isNaN(itm)).map((itm, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        {key + 1}.
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{moment(record[itm]?.expiry)?.format('MM/YYYY')}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{record[itm]?.batchNo}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{record[itm]?.quantity}</div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        ),
                        rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                />
            </div>
        </Drawer>
    )
}

export default StockTakeTally